document.addEventListener('DOMContentLoaded', function () {

  var root = document.getElementById('ffBraFinder');

  if (!root) return;


  /* =====================================================
     FEMIFEMME BH FINDER
     ===================================================== */

  var needButtons =
    root.querySelectorAll('.ffbf-need');

  var bustButtons =
    root.querySelectorAll('.ffbf-bust button');

  var findButton =
    document.getElementById('ffFindBras');

  var finderError =
    document.getElementById('ffFinderError');

  var results =
    document.getElementById('ffBraResults');

  var resultGrid =
    document.getElementById('ffBraResultGrid');

  var whyBox =
    document.getElementById('ffBraWhy');


  /*
    Shopify har fjernet data-attributterne fra sidekoden.
    Vi sætter dem derfor her automatisk.
  */

  var needKeys = [
    'support',
    'coverage',
    'pushup',
    'natural',
    'soft',
    'feminine',
    'gel',
    'airy'
  ];


  var bustKeys = [
    'small',
    'medium',
    'full'
  ];


  for (var i = 0; i < needButtons.length; i++) {

    needButtons[i].setAttribute(
      'data-need',
      needKeys[i] || ''
    );

  }


  for (var b = 0; b < bustButtons.length; b++) {

    bustButtons[b].setAttribute(
      'data-bust',
      bustKeys[b] || ''
    );

  }


  var selectedBust = '';


  /* =====================================================
     PRODUKTDATA
     ===================================================== */

  var products = {

    flexi: {

      name: 'FlexiComfort',

      url: '/collections/flexicomfort',

      badge: 'Mest dækkende',

      badgeClass: '',

      description:
        'Klassisk og dækkende hverdags-BH med stabil pasform og medium støtte.',

      tags: [
        'B–E',
        'Medium støtte',
        'T-shirt BH'
      ],

      image:
        'https://femifemme.dk/cdn/shop/files/Flexicomfortskin.png?v=1786956594&width=700',

      scores: {
        support: 4,
        coverage: 5,
        pushup: 2,
        natural: 3,
        soft: 4,
        feminine: 2,
        gel: 0,
        airy: 2
      },

      bust: {
        small: 1,
        medium: 4,
        full: 5
      }

    },


    scallop: {

      name: 'SoftScallop',

      url: '/collections/softscallop',

      badge: 'Ekstra gelstøtte',

      badgeClass:
        'ffbf-product-badge--gel',

      description:
        'Feminin og dækkende BH med ekstra gelstøtte under barmen for mere stabilitet.',

      tags: [
        'B–E',
        'Ekstra gelstøtte',
        'Feminin'
      ],

      image:
        'https://femifemme.dk/cdn/shop/files/SoftScallop_Full_Coverage_Boejlefri_BH_-_Nude_40a7a211-2af9-496a-8983-213b7bc4c57c.jpg?v=1771349999&width=700',

      scores: {
        support: 5,
        coverage: 4,
        pushup: 2,
        natural: 3,
        soft: 4,
        feminine: 5,
        gel: 5,
        airy: 2
      },

      bust: {
        small: 1,
        medium: 4,
        full: 5
      }

    },


    airlift: {

      name: 'Airlift',

      url: '/collections/airlift',

      badge: 'Mest push-up',

      badgeClass:
        'ffbf-product-badge--air',

      description:
        'Let og åndbar BH med udtagelige push-up pads og mulighed for markant løft og fylde.',

      tags: [
        'A–E*',
        'Push-up',
        'Udtagelige pads'
      ],

      image:
        'https://femifemme.dk/cdn/shop/files/Airlift_Sand-7.png?v=1783276774&width=700',

      scores: {
        support: 3,
        coverage: 2,
        pushup: 5,
        natural: 3,
        soft: 3,
        feminine: 4,
        gel: 0,
        airy: 5
      },

      bust: {
        small: 5,
        medium: 5,
        full: 3
      }

    },


    gravity: {

      name: 'GravityLess',

      url: '/collections/gravityless',

      badge: 'Naturligt løft',

      badgeClass: '',

      description:
        'Let og naturlig BH til den mindre barm med udtagelige pads og let til medium støtte.',

      tags: [
        'A–C',
        'Naturligt løft',
        'Udtagelige pads'
      ],

      image:
        'https://femifemme.dk/cdn/shop/files/GravityLess_Soemloes_boejlefri_BH_-_Nude_3.png?v=1777032761&width=700',

      scores: {
        support: 2,
        coverage: 2,
        pushup: 2,
        natural: 5,
        soft: 4,
        feminine: 3,
        gel: 0,
        airy: 4
      },

      bust: {
        small: 5,
        medium: 2,
        full: 0
      }

    },


    antigravity: {

      name: 'Antigravity',

      url: '/collections/antigravitiy',

      badge:
        'Push-up til mindre barm',

      badgeClass: '',

      description:
        'Push-up model til mindre barm med udtagelige pads og mulighed for ekstra fylde.',

      tags: [
        'A–C',
        'Push-up',
        'Udtagelige pads'
      ],

      image:
        'https://femifemme.dk/cdn/shop/files/Antigravity_soemloes_boejlefri_Push_Up_BH_-_Hvid_5.png?v=1776939883&width=700',

      scores: {
        support: 2,
        coverage: 1,
        pushup: 5,
        natural: 2,
        soft: 3,
        feminine: 4,
        gel: 0,
        airy: 3
      },

      bust: {
        small: 5,
        medium: 2,
        full: 0
      },

      outgoing: true

    },


    softwave: {

      name: 'SoftWave',

      url:
        '/collections/softwave-bralette',

      badge: 'Ekstra blød',

      badgeClass: '',

      description:
        'Blød og feminin hverdags-BH med medium støtte og seamless komfort.',

      tags: [
        'B–E',
        'Blød komfort',
        'Medium støtte'
      ],

      image:
        'https://femifemme.dk/cdn/shop/files/SoftWave_Full_Coverage_Boejlefri_BH_-_Nude_skin_1.png?v=1776961967&width=700',

      scores: {
        support: 3,
        coverage: 3,
        pushup: 2,
        natural: 3,
        soft: 5,
        feminine: 4,
        gel: 0,
        airy: 3
      },

      bust: {
        small: 1,
        medium: 4,
        full: 4
      },

      alwaysLast: true

    }

  };


  /* =====================================================
     VALG
     ===================================================== */

  needButtons.forEach(function (button) {

    button.addEventListener(
      'click',
      function () {

        this.classList.toggle(
          'is-active'
        );

        if (finderError) {
          finderError.style.display =
            'none';
        }

      }
    );

  });


  bustButtons.forEach(function (button) {

    button.addEventListener(
      'click',
      function () {

        bustButtons.forEach(
          function (item) {

            item.classList.remove(
              'is-active'
            );

          }
        );


        this.classList.add(
          'is-active'
        );


        selectedBust =
          this.getAttribute(
            'data-bust'
          );


        if (finderError) {

          finderError.style.display =
            'none';

        }

      }
    );

  });


  function getSelectedNeeds() {

    var active =
      root.querySelectorAll(
        '.ffbf-need.is-active'
      );

    var values = [];


    active.forEach(function (item) {

      var value =
        item.getAttribute(
          'data-need'
        );

      if (value) {

        values.push(value);

      }

    });


    return values;

  }


  /* =====================================================
     FIND BH
     ===================================================== */

  function calculateBras() {

    var selectedNeeds =
      getSelectedNeeds();


    if (
      selectedNeeds.length === 0
    ) {

      finderError.textContent =
        'Vælg mindst én ting, der er vigtig for dig.';

      finderError.style.display =
        'block';

      return;

    }


    if (!selectedBust) {

      finderError.textContent =
        'Vælg også hvordan du vil beskrive din barm.';

      finderError.style.display =
        'block';

      return;

    }


    var scored = [];


    Object.keys(products).forEach(
      function (key) {

        var product =
          products[key];

        var score = 0;


        selectedNeeds.forEach(
          function (need) {

            score +=
              product.scores[need] || 0;

          }
        );


        score +=
          (
            product.bust[
              selectedBust
            ] || 0
          ) * 2;


        /*
          Antigravity er udgående og
          bliver derfor lidt nedprioriteret.
        */

        if (product.outgoing) {
          score -= 3;
        }


        scored.push({

          key: key,
          product: product,
          score: score

        });

      }
    );


    /*
      SoftWave skal altid ligge efter
      de aktive kernemodeller.
    */

    scored.sort(
      function (a, b) {

        if (
          a.product.alwaysLast &&
          !b.product.alwaysLast
        ) {
          return 1;
        }

        if (
          b.product.alwaysLast &&
          !a.product.alwaysLast
        ) {
          return -1;
        }

        return b.score - a.score;

      }
    );


    renderBras(
      scored.slice(0, 3),
      selectedNeeds
    );

  }


  function renderBras(
    recommendations,
    selectedNeeds
  ) {

    var html = '';


    recommendations.forEach(
      function (item, index) {

        var p =
          item.product;

        var rank = '';

        if (index === 0) {
          rank = 'Bedste match';
        }

        else if (index === 1) {
          rank = 'Stærkt valg';
        }

        else {
          rank = 'Også et godt match';
        }


        var tags = '';

        p.tags.forEach(
          function (tag) {

            tags +=
              '<span>' +
              tag +
              '</span>';

          }
        );


        var note = '';


        if (
          item.key === 'airlift' &&
          selectedBust === 'full'
        ) {

          note +=
            '<div class="ffbf-product-note">' +
            'Ved en fyldigere barm anbefaler vi, at de udtagelige push-up pads tages ud. Det giver mere plads i skålen.' +
            '</div>';

        }


        html +=

          '<article class="ffbf-product">' +

            '<div class="ffbf-product-image">' +

              '<span class="ffbf-product-badge ' +
                p.badgeClass +
              '">' +
                p.badge +
              '</span>' +

              '<img src="' +
                p.image +
              '" alt="' +
                p.name +
              '" loading="lazy">' +

            '</div>' +


            '<div class="ffbf-product-body">' +

              '<div class="ffbf-product-rank">' +
                rank +
              '</div>' +

              '<h3>' +
                p.name +
              '</h3>' +

              '<p>' +
                p.description +
              '</p>' +

              '<div class="ffbf-tags">' +
                tags +
              '</div>' +

              note +

              '<a href="' +
                p.url +
              '">' +
                'Se ' +
                p.name +
              '</a>' +

            '</div>' +

          '</article>';

      }
    );


    resultGrid.innerHTML =
      html;


    var names = {

      support: 'ekstra støtte',
      coverage: 'mere dækning',
      pushup: 'push-up og fylde',
      natural: 'naturligt løft',
      soft: 'blød komfort',
      feminine: 'feminin pasform',
      gel: 'ekstra gelstøtte',
      airy: 'let og åndbar komfort'

    };


    var readable =
      selectedNeeds.map(
        function (need) {

          return names[need];

        }
      );


    whyBox.innerHTML =
      '<strong>Hvorfor disse modeller?</strong> ' +
      'Du har valgt ' +
      readable.join(', ') +
      '. Vi har samtidig taget højde for, hvordan du beskriver din barm.';


    results.style.display =
      'block';


    setTimeout(function () {

      results.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      });

    }, 80);

  }


  if (findButton) {

    findButton.addEventListener(
      'click',
      calculateBras
    );

  }


  /* =====================================================
     STØRRELSESFINDER
     ===================================================== */

  var underInput =
    document.getElementById(
      'ffSizeUnder'
    );

  var bustInput =
    document.getElementById(
      'ffSizeBust'
    );

  var bandInput =
    document.getElementById(
      'ffSizeBand'
    );

  var cupInput =
    document.getElementById(
      'ffSizeCup'
    );

  var knowYes =
    document.getElementById(
      'ffSizeKnowYes'
    );

  var knowNo =
    document.getElementById(
      'ffSizeKnowNo'
    );

  var known =
    document.getElementById(
      'ffSizeKnown'
    );

  var unknown =
    document.getElementById(
      'ffSizeUnknown'
    );

  var sizeButton =
    document.getElementById(
      'ffSizeCalculate'
    );

  var sizeError =
    document.getElementById(
      'ffSizeError'
    );

  var sizeResult =
    document.getElementById(
      'ffSizeResult'
    );

  var sizeBig =
    document.getElementById(
      'ffSizeResultBig'
    );

  var resultUnder =
    document.getElementById(
      'ffSizeResultUnder'
    );

  var resultCup =
    document.getElementById(
      'ffSizeResultCup'
    );

  var resultBand =
    document.getElementById(
      'ffSizeResultBand'
    );

  var resultCupLabel =
    document.getElementById(
      'ffSizeCupLabel'
    );

  var explanation =
    document.getElementById(
      'ffSizeExplanation'
    );


  var sizeChart = {

    65: {
      AB: 'XS',
      CD: 'XS',
      E: null
    },

    70: {
      AB: 'S',
      CD: 'S',
      E: null
    },

    75: {
      AB: 'S',
      CD: 'M',
      E: 'M'
    },

    80: {
      AB: 'M',
      CD: 'L',
      E: 'L'
    },

    85: {
      AB: 'L',
      CD: 'XL',
      E: 'XL'
    },

    90: {
      AB: 'L',
      CD: 'XL',
      E: 'XXL'
    },

    95: {
      AB: 'XL',
      CD: 'XXL',
      E: 'XXXL'
    },

    100: {
      AB: 'XXL',
      CD: 'XXXL',
      E: null
    }

  };


  function updateSizeMethod() {

    sizeResult.style.display =
      'none';

    sizeError.style.display =
      'none';


    if (knowNo.checked) {

      known.classList.add(
        'ff-hidden'
      );

      unknown.classList.remove(
        'ff-hidden'
      );

      sizeButton.textContent =
        'Beregn min størrelse';

    }

    else {

      unknown.classList.add(
        'ff-hidden'
      );

      known.classList.remove(
        'ff-hidden'
      );

      sizeButton.textContent =
        'Find min størrelse';

    }

  }


  knowYes.addEventListener(
    'change',
    updateSizeMethod
  );

  knowNo.addEventListener(
    'change',
    updateSizeMethod
  );


  function getGuideBand(value) {

    var bands = [
      65,
      70,
      75,
      80,
      85,
      90,
      95,
      100
    ];


    if (
      value < 64 ||
      value > 101
    ) {
      return null;
    }


    if (value <= 65) {
      return 65;
    }


    for (
      var i = 0;
      i < bands.length - 1;
      i++
    ) {

      var lower =
        bands[i];

      var upper =
        bands[i + 1];


      if (value === lower) {
        return lower;
      }


      if (
        value > lower &&
        value < upper
      ) {

        if (
          upper - value <= 1
        ) {
          return upper;
        }

        return lower;

      }


      if (value === upper) {
        return upper;
      }

    }


    return 100;

  }


  function estimateCup(
    under,
    bust
  ) {

    var difference =
      bust - under;


    if (difference < 14) {
      return 'A';
    }

    if (difference < 16) {
      return 'B';
    }

    if (difference < 18) {
      return 'C';
    }

    if (difference < 20) {
      return 'D';
    }

    return 'E';

  }


  function getCupGroup(cup) {

    if (
      cup === 'A' ||
      cup === 'B'
    ) {
      return 'AB';
    }


    if (
      cup === 'C' ||
      cup === 'D'
    ) {
      return 'CD';
    }


    if (cup === 'E') {
      return 'E';
    }


    return null;

  }


  function showSizeError(text) {

    sizeError.textContent =
      text;

    sizeError.style.display =
      'block';

    sizeResult.style.display =
      'none';

  }


  function calculateSize() {

    sizeError.style.display =
      'none';


    var under =
      parseFloat(
        underInput.value
      );


    if (!under) {

      showSizeError(
        'Indtast dit mål under brystet.'
      );

      return;

    }


    var guideBand =
      getGuideBand(under);


    if (!guideBand) {

      showSizeError(
        'Dit mål ligger uden for vores standardguide. Kontakt gerne kundeservice.'
      );

      return;

    }


    var cup = '';

    var normalBand = '';

    var calculated = false;


    if (knowYes.checked) {

      normalBand =
        bandInput.value;

      cup =
        cupInput.value;


      if (!normalBand) {

        showSizeError(
          'Vælg den BH-omkreds du normalt bruger.'
        );

        return;

      }


      if (!cup) {

        showSizeError(
          'Vælg den skålstørrelse du normalt bruger.'
        );

        return;

      }

    }


    else {

      var bust =
        parseFloat(
          bustInput.value
        );


      if (!bust) {

        showSizeError(
          'Indtast også dit mål over brystets fyldigste sted.'
        );

        bustInput.focus();

        return;

      }


      if (bust <= under) {

        showSizeError(
          'Målet over brystet skal være større end målet under brystet.'
        );

        return;

      }


      cup =
        estimateCup(
          under,
          bust
        );

      calculated = true;

    }


    var group =
      getCupGroup(cup);


    var size =
      sizeChart[
        guideBand
      ][
        group
      ];


    if (!size) {

      showSizeError(
        'Denne kombination ligger uden for vores standardguide. Kontakt gerne kundeservice.'
      );

      return;

    }


    sizeBig.textContent =
      size;

    resultUnder.textContent =
      under + ' cm';

    resultBand.textContent =
      guideBand + ' cm';


    if (calculated) {

      resultCupLabel.textContent =
        'Vejledende skål';

      resultCup.textContent =
        'ca. ' + cup;

    }

    else {

      resultCupLabel.textContent =
        'Din normale BH';

      resultCup.textContent =
        normalBand + cup;

    }


    if (under === guideBand) {

      explanation.innerHTML =
        '<strong>Et direkte match</strong>' +
        'Dit mål passer direkte til vores guide. Vi anbefaler derfor størrelse ' +
        size +
        '.';

    }

    else if (under < guideBand) {

      explanation.innerHTML =
        '<strong>Du er tæt på næste størrelse</strong>' +
        'Du ligger kun ca. 1 cm fra næste omkredsstørrelse. Derfor anbefaler vi størrelse ' +
        size +
        '.';

    }

    else {

      explanation.innerHTML =
        '<strong>Du ligger mellem to størrelser</strong>' +
        'Femifemmes BH’er er fleksible og ikke små i størrelsen. Derfor anbefaler vi som udgangspunkt den mindre størrelse: ' +
        size +
        '.';

    }


    if (calculated) {

      explanation.innerHTML +=
        '<br><br><strong>Skålen er vejledende estimeret</strong>' +
        'Vi har beregnet skålgruppen ud fra forskellen mellem dine to mål. Brystform og BH-mærke kan give variation.';

    }


    sizeResult.style.display =
      'block';


    setTimeout(function () {

      sizeResult.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest'
      });

    }, 80);

  }


  if (sizeButton) {

    sizeButton.addEventListener(
      'click',
      calculateSize
    );

  }

});